/**
 * ColorPickerPopover.tsx
 *
 * ColorPicker dentro de un Popover de shadcn.
 * El trigger es el color actual del elemento (avatar, badge, dot).
 *
 * Uso:
 *   <ColorPickerPopover
 *     value="red-ember"
 *     onSelect={(token) => handleChange(token)}
 *     trigger={<div style={{ background: color }} className="size-6 rounded-full" />}
 *   />
 */

import { Popover, PopoverContent, PopoverTrigger } from '@/shared/components/ui/popover';
import { ColorPicker } from './ColorPicker';

/* ── Props ──────────────────────────────────────────────────── */

export interface ColorPickerPopoverProps {
  /** Token del color actualmente seleccionado */
  value?: string;
  /** Callback al seleccionar — recibe el token string */
  onSelect: (token: string) => void;
  /** Elemento que abre el popover al hacer click */
  trigger: React.ReactNode;
  /** Cierra el popover automáticamente al seleccionar un color */
  closeOnSelect?: boolean;
  disabled?: boolean;
  'data-testid'?: string;
}

export function ColorPickerPopover({
  value,
  onSelect,
  trigger,
  // closeOnSelect = true,
  disabled = false,
  'data-testid': testId,
}: ColorPickerPopoverProps) {
  function handleSelect(token: string) {
    onSelect(token);
  }

  return (
    <Popover>
      <PopoverTrigger asChild disabled={disabled}>
        {trigger}
      </PopoverTrigger>
      <PopoverContent className="w-auto p-3" align="start" sideOffset={6}>
        <ColorPicker
          value={value}
          onSelect={(token) => {
            handleSelect(token);
          }}
          size="md"
          data-testid={testId}
        />
      </PopoverContent>
    </Popover>
  );
}
